import { useEffect, useState } from 'react';

interface PageLoadAnimationState {
  logoVisible: boolean;
  navItemsVisible: boolean;
  headlineVisible: boolean;
  subtextVisible: boolean;
  ctaVisible: boolean;
  visualVisible: boolean;
}

export const usePageLoadAnimation = () => {
  const [state, setState] = useState<PageLoadAnimationState>({
    logoVisible: false,
    navItemsVisible: false,
    headlineVisible: false,
    subtextVisible: false,
    ctaVisible: false,
    visualVisible: false,
  });

  useEffect(() => {
    // Logo fades in first (300ms)
    const logoTimer = setTimeout(() => {
      setState((prev) => ({ ...prev, logoVisible: true }));
    }, 100);

    // Nav items stagger in from top (50ms delay each) - starts at 300ms
    const navTimer = setTimeout(() => {
      setState((prev) => ({ ...prev, navItemsVisible: true }));
    }, 300);

    // Hero headline slides up with opacity fade (600ms)
    const headlineTimer = setTimeout(() => {
      setState((prev) => ({ ...prev, headlineVisible: true }));
    }, 600);

    // Hero subtext follows (800ms delay)
    const subtextTimer = setTimeout(() => {
      setState((prev) => ({ ...prev, subtextVisible: true }));
    }, 800);

    // CTA buttons pop in (1000ms delay)
    const ctaTimer = setTimeout(() => {
      setState((prev) => ({ ...prev, ctaVisible: true }));
    }, 1000);

    // Hero visual floats in from right (700ms)
    const visualTimer = setTimeout(() => {
      setState((prev) => ({ ...prev, visualVisible: true }));
    }, 700);

    return () => {
      clearTimeout(logoTimer);
      clearTimeout(navTimer);
      clearTimeout(headlineTimer);
      clearTimeout(subtextTimer);
      clearTimeout(ctaTimer);
      clearTimeout(visualTimer);
    };
  }, []);

  return state;
};

export default usePageLoadAnimation;